import { render, staticRenderFns } from "./ChangeBillingCourseModal.vue?vue&type=template&id=2712cd62&scoped=true&"
import script from "./ChangeBillingCourseModal.vue?vue&type=script&lang=js&"
export * from "./ChangeBillingCourseModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangeBillingCourseModal.vue?vue&type=style&index=0&id=2712cd62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2712cd62",
  null
  
)

export default component.exports